/**
 * Memoria de un solo uso del cliente que el administrador tenía abierto en
 * la pantalla Clientes.
 *
 * El detalle del cliente es estado de React, no una ruta: al ir a otra
 * pantalla (Dispositivos, Cambiar Contraseña, Promesa) o al recargar, la
 * pantalla Clientes se destruye y ese estado se pierde. Antes de salir se
 * guarda aquí, y cuando Clientes vuelve a montarse lo abre de nuevo.
 *
 * Vive en sessionStorage: sobrevive a una recarga y a ir y volver, pero no
 * a cerrar la app. El Menú lo olvida a propósito: si el usuario vuelve al
 * inicio, ya no está "dentro" de ese cliente.
 */
const CLAVE = 'clientes_detalle_abierto';

export function guardarDetalleAbierto(detalle: unknown): void {
  try {
    if (detalle) sessionStorage.setItem(CLAVE, JSON.stringify(detalle));
  } catch { /* sin almacenamiento, simplemente no se recuerda */ }
}

export function leerDetalleAbierto<T>(): T | null {
  try {
    const guardado = sessionStorage.getItem(CLAVE);
    return guardado ? (JSON.parse(guardado) as T) : null;
  } catch {
    return null;
  }
}

export function olvidarDetalleAbierto(): void {
  try { sessionStorage.removeItem(CLAVE); } catch { /* nada que olvidar */ }
}
